module.exports = {
    props: ['user', 'teams'],

    /**
     * The component's data.
     */
    data() {
        return {
            token: '',
            form: new SparkForm({

            })
        };
    },
};


